import jsPDF from 'jspdf';
import {autoTable} from 'jspdf-autotable';
import caveatColor from '../caveatColor';
import {getCaveatScores, posAttributes, staticCaveats} from "../components/resultItems/CondensedCaveatAvatars";
import {OptionSummaryRpts} from '../Reports/OptionSummaryRpt'
import * as rptHelpers from "../Reports/ReportHelpers";
import {SECTION_TITLES} from '../containers/AnswersList';

export function createSummaryRpt(selectedItems, options, section, fishery, pageOrientation, pageFormat, answers, answerTextLookup, questionLookup, notesList, includeDesc, includeNotes, includeCrit, includeCavs, starred, translation){
    var doc = new jsPDF(pageOrientation, 'mm', pageFormat);
    var formatValues = rptHelpers.getFormatValues(doc);

    //*********************
    //Title Page
    //*********************

    //title
    doc.setFontSize(36);
    doc.setFont(rptHelpers.RPTFONTSTYLE, "bold");
    var yPos = 35;
    doc.text(formatValues.titleXPos, yPos, "Selected FishPath Results for", null, null, 'center');
    yPos+=15
    var fisheryTxt = doc.splitTextToSize(fishery, formatValues.splitWidth);
    doc.text(formatValues.titleXPos, yPos, fisheryTxt, null, null, 'center');

    //logo
    rptHelpers.placeTitleLogo(doc)

    //date
    yPos += fisheryTxt.length * 30;
    var date = new Date();
    doc.setFontSize(20);
    doc.text(formatValues.titleXPos, yPos, "Report Generated on " + date.toLocaleDateString("en-us", {year: 'numeric', day: 'numeric', month:'long'}), null, null, 'center');

    //*********************
    //Description/instructions for summary report
    //*********************
    rptHelpers.addNewPage(doc);
    yPos = 15;
    doc.text(formatValues.titleXPos, yPos, "Introduction and Definitions", null, null, 'center');
    yPos += 10;


    doc.setFontSize(12)
    var text = doc.splitTextToSize("The following report contains information about user-selected results from the FishPath questionnaire. (Note that this report might not include all results provided in FishPath.) The first section, \"Summary of Selected Results\" provides a table containing each selected option and a summary of its associated results. The second section provides detailed information about each the results for each selected option as well as any notes that were written within FishPath for the option.", formatValues.splitWidth)
    doc.text(rptHelpers.HMARGIN, yPos, text)
    yPos += text.length*6

    //yPos += 5
    doc.setFont(rptHelpers.RPTFONTSTYLE, 'bold')
    doc.setFontSize(14)
    doc.text(rptHelpers.HMARGIN, yPos, "Definitions")
    yPos += 7;

    doc.setFontSize(11)

    if(section!=="controlRules"){
      doc.text(rptHelpers.HMARGIN, yPos, "Criteria: ")
      yPos+=6
      doc.setFont(rptHelpers.RPTFONTSTYLE, 'normal')
      text = doc.splitTextToSize("Criteria are the minimum requirements needed to implement the option. If all criteria for an option are met, then an option may be implemented, pending further consideration of the caveats. If one or more criteria is not met, then it will not be possible (or extremely difficult) to implement the option successfully. Whether or not a criteria is met is based upon the answers to the fishery questionnaire. Both data collection and assessment options have criteria associated with them. Additionally, assessment options further indicate the uncertainty around met criteria. The level of uncertainty is indicated by a \"traffic light\" of colors (red, orange, yellow, green). Red indicates a high level of possible uncertainty, while green indicates a low level of possible uncertainty. These are indicated as the background color in the met/failed column.", formatValues.splitWidth-5)
      doc.text(rptHelpers.HMARGIN+5, yPos, text);
      yPos += text.length*5
    }

    if(section === "assessment"){
      doc.setFont(rptHelpers.RPTFONTSTYLE, 'bold')
      doc.text(rptHelpers.HMARGIN+10, yPos, "Multi-part Criterion: ")
      yPos+=6
      doc.setFont(rptHelpers.RPTFONTSTYLE, 'normal')
      text = doc.splitTextToSize("A group of criteria that are considered together when determining if they meet the minimum requirements. To meet a multi-part criterion, at least one of the associated criteria must meet its minimum requirements. Multi-part criterions are signified in the table below by grouping each criteria together under the multi-part criterion (e.g. Group A).", formatValues.splitWidth-15)
      doc.text(rptHelpers.HMARGIN+15, yPos, text)
      yPos += text.length*5
    }

    doc.setFont(rptHelpers.RPTFONTSTYLE, 'bold')
    doc.text(rptHelpers.HMARGIN, yPos, "Caveat: ")
    yPos+=6
    doc.setFont(rptHelpers.RPTFONTSTYLE, 'normal')
    text = doc.splitTextToSize("Caveats indicate cautions to be aware of when implementing this option for this specific fishery. Caveats, except for static caveats, are determined based upon the answers to the fishery questionnaire. Caveats are ranked in severity from red to orange to yellow to light blue. Red caveats represent the strongest cautions, suggesting that those options should likely not be implemented without serious consideration for overcoming that caveat.  Where yellow caveats may provide a caution to consider, but that may not prevent implementation. Light blue caveats are neutral and used to provide additional information about the option, given the context. Color assignments are based on expert experience and may vary among fisheries.", formatValues.splitWidth-5)
    doc.text(rptHelpers.HMARGIN+5, yPos, text)
    yPos += text.length*5

    doc.setFont(rptHelpers.RPTFONTSTYLE, 'bold')
    doc.text(rptHelpers.HMARGIN+10, yPos, "Static Caveat: ")
    yPos+=6
    doc.setFont(rptHelpers.RPTFONTSTYLE,'normal')
    text = doc.splitTextToSize("Static caveats provide additional information, assumptions, limitations, or warnings associated with the option that apply independently of fishery circumstances or user responses to the questionnaire. They are denoted with light blue.", formatValues.splitWidth-15)
    doc.text(rptHelpers.HMARGIN+15, yPos, text)
    yPos += text.length*5

    yPos += 2; //to make spacing equal since above has less lines
    doc.setFont(rptHelpers.RPTFONTSTYLE, 'bold')
    doc.text(rptHelpers.HMARGIN+10, yPos, "Positive Attribute: ")
    yPos+=6
    doc.setFont(rptHelpers.RPTFONTSTYLE, 'normal')
    text = doc.splitTextToSize("Positive attributes indicate reasons why an option might be a good fit for the fishery. They are determined based upon the answers to the fishery questionnaire and are denoted with green.", formatValues.splitWidth-15)
    doc.text(rptHelpers.HMARGIN+15, yPos, text)
    yPos += text.length*5

    //*********************
    //Summary report
    //*********************
    doc.addPage();
    yPos = 15;

    doc.setFontSize(20);
    doc.setFont(rptHelpers.RPTFONTSTYLE, "bold");
    doc.text(rptHelpers.HMARGIN, yPos, "Summary of Selected Results");

    doc.setFontSize(16);
    doc.setFont(rptHelpers.RPTFONTSTYLE, 'normal');
    yPos += 7;
    var fisheryText = "Fishery: " + fishery;
    fisheryText = doc.splitTextToSize(fisheryText, formatValues.splitWidth);
    doc.text(rptHelpers.HMARGIN+5, yPos, fisheryText)

    yPos += 7*fisheryText.length;
    doc.text(rptHelpers.HMARGIN+5, yPos, "Section: " + SECTION_TITLES[section])
    yPos += 10;
    doc.setFontSize(14);

    var columns = [
      {title: "Option", dataKey:"optCol"},
      {title: (section !== "assessment") ? "Category" : "Assessment\nOutput", dataKey:"catCol"},
      {title: "Red\nCaveats", dataKey:"red"},
      {title: "Orange\nCaveats", dataKey:"orange"},
      {title: "Yellow\nCaveats", dataKey:"yellow"},
      {title: "Positive\nAttributes", dataKey:"green"},
      {title: "Static\nCaveats", dataKey:"static"}
    ];

    if(section !== "controlRules"){
      columns.splice(2,0, {title: "Meets\nCriteria", dataKey:"mc"})
    }
    if(section === "assessment"){
      columns.splice(1,0, {title:"Assessment\nCategory", dataKey:"inputCat"})
    }
    var minCavWidth = (pageOrientation === 'l') ? 17 : 12

    doc.autoTable(columns, getData(selectedItems, options, starred),{
      willDrawCell: specialCellFormats,
      styles: {overflow: 'linebreak', cellWidth:'auto'},
      columnStyles: {
        optCol: {minCellWidth: 67},
        catCol: {minCellWidth: 20},
        inputCat: {minCellWidth: 20},
        red: {minCellWidth: minCavWidth, halign: 'center'},
        orange: {minCellWidth: minCavWidth, halign: 'center'},
        yellow: {minCellWidth: minCavWidth, halign: 'center'},
        green: {minCellWidth: minCavWidth, halign: 'center'},
        static: {minCellWidth: minCavWidth, halign: 'center'},
        mc: {minCellWidth: minCavWidth+4, halign: 'center'}
      },
      startY: yPos,
      rowPageBreak: 'avoid',
      margin: {horizontal: rptHelpers.HMARGIN, bottom: 19},
      addPageContent: rptHelpers.tableFooter,
    });

    //*************************
    //Results Detail Report
    //*************************
    OptionSummaryRpts(doc, selectedItems, options, answerTextLookup, questionLookup, notesList, fishery, pageOrientation, pageFormat, section, includeDesc, includeNotes, includeCrit, includeCavs, starred, translation);

    //generate the report in a new tab
    var blob = doc.output("blob");
    window.open(URL.createObjectURL(blob));
}


export const specialCellFormats = (data) => {
  if(data.row.section === 'head'){
    switch(data.column.raw.dataKey){
    case 'red':
      data.doc.setFillColor(...caveatColor(-3).primaryRGBArr);
      break;
    case 'orange':
      data.doc.setFillColor(...caveatColor(-2).primaryRGBArr);
      break;
    case 'yellow':
      data.doc.setFillColor(...caveatColor(-1).primaryRGBArr);
      data.doc.setTextColor(0,0,0); //black
      break;
    case 'green':
      data.doc.setFillColor(...caveatColor(2).primaryRGBArr);
      break;
    case 'static':
      data.doc.setFillColor(...caveatColor(0).primaryRGBArr);
      break;
    default:
      break;
    }
  } else if(data.row.section === 'body' && data.column.dataKey === "optCol"){
    if(data.cell.raw.includes("Top Option:")){
      data.doc.setFont(rptHelpers.RPTFONTSTYLE, 'bold')
      for(const cell of Object.values(data.row.cells)){
        cell.styles.fontStyle = 'bold';
      }
    }
  }
}

const getData = (selectedItems, options, starred) => {
  let optList = selectedItems.map((id) => {
    var option;
    for(var i=0; i < options.length; i++){
      if(id === options[i].id){
        option = options[i];
        break;
      }
    }

    let optTitle = starred.indexOf(option.id) === -1 ? option.title : "Top Option: " + option.title
    var scores = getCaveatScores(option.caveats);
    var numCritMet = rptHelpers.countCriteria(option.metCriteria, option);
    var numCritTotal = numCritMet + rptHelpers.countCriteria(option.eliminatedBy, option);
    var meetsCrit = (option.eliminated === true) ? "No" : "Yes";
    meetsCrit += " (" + numCritMet + "/" + numCritTotal + ")";
    var numYellowCavs = scores['-1'] ? scores['-1'] : "0";
    var numOrangeCavs = scores['-2'] ? scores['-2'] : "0";
    var numRedCavs = scores['-3'] ? scores['-3'] : "0";
    var numPosAtt = posAttributes(option.caveats).length;
    var numStaticCavs = staticCaveats(option.caveats).length;
    var inputCatTitle = option.inputCategory ? option.inputCategory.title : ""

    return {optCol: optTitle, catCol: option.category.title, inputCat:inputCatTitle, mc: meetsCrit, green: numPosAtt, yellow: numYellowCavs, orange: numOrangeCavs, red: numRedCavs, static: numStaticCavs}
  });

  return optList;
}
